import useTranslation from 'modules/localization';
import React from 'react';
import { connect } from 'react-redux';
import { authService } from 'services';
import getPlatformCode from 'shared/utils/getPlatformCode';
import storeManager from 'store/manager';
import { RootState } from 'store/types';
import { Nullable } from "shared/global/types";

interface Props {
    accountNo: Nullable<number>,
}

const HeaderMenu = (props: Props) => {
    const [platformCode, setPlatformCode] = React.useState('');
    const accountNo = props.accountNo;
    const { t } = useTranslation();

    React.useEffect(() => {
        setTimeout(() => {
            const code = getPlatformCode();
            setPlatformCode(code);
        });

    }, [props.accountNo])

    const handleLogoutClick = async () => {
        authService.logout();
    }

    const handleSettingsClick = () => {
        storeManager.modal.setSettings({ visibility: true, data: null })
    }

    const handleTradingAccountsClick = () => {
        storeManager.modal.setTradingAccounts({ visibility: true, data: null })
    }

    return (
        <div className="header-menu">
            <div className="column">
                <div className="tm-acc-title">{t('TradingAccounts')}</div>
                <div>{platformCode} #{accountNo}</div>
            </div>
            <div className="column tm-icon-wrapper">
                <div onClick={handleTradingAccountsClick} className="change-accounts"><i className="icofont-exchange"></i></div>
                <div className="settings" onClick={handleSettingsClick}><i className="icofont-gear"></i></div>
                <div onClick={handleLogoutClick}><i className="icofont-logout"></i></div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    accountNo: state.account.accountNo
})

export default connect(mapStateToProps)(HeaderMenu);